<div *ngIf="setups.length > 0" class="flex flex-col mt-10">
  <div class="overflow-x-auto">
    <div class="inline-block min-w-full py-2 overflow-x-auto overflow-y-auto align-middle">
      <div class="overflow-hidden">
        <table class="min-w-full">
          <thead class="border-b border-gray-400">
            <tr>
              <th scope="col" class="px-6 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Status
              </th>

              <th scope="col" class="px-6 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Nome
              </th>

              <th scope="col" class="px-6 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Empresa
              </th>

              <th
                scope="col"
                class="px-6 py-3 font-bold tracking-wider text-center uppercase text-chathams-blue"
                *isAllowed="[ERoleAdminString.Admin, 'setup.edit']"
              >
                Ações
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="bg-white hover:bg-iceberg" *ngFor="let setup of setups">
              <td class="px-6 py-4 font-medium text-md text-chathams-blue whitespace-nowrap">
                <app-status-switch [active]="setup.active" [itemName]="'setup ' + setup.name"></app-status-switch>
              </td>
              <td class="px-6 py-4 font-medium text-md text-chathams-blue whitespace-nowrap">
                {{ setup.name }}
              </td>

              <td class="px-6 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
                {{ setup.company.name }}
              </td>

              <td
                class="flex justify-center px-6 py-4 whitespace-normal text-md text-chathams-blue"
                *isAllowed="[ERoleAdminString.Admin, 'setup.edit']"
              >
                <a
                  *isAllowed="[ERoleAdminString.Admin, 'setup.edit']"
                  [routerLink]="'editar/' + setup.id"
                  class="flex items-center justify-center w-8 h-8 rounded-full bg-iceberg"
                  [attr.aria-label]="'Editar setup ' + setup.name"
                  [title]="'Editar setup ' + setup.name"
                >
                  <lucide-icon name="pencil" [size]="18"></lucide-icon>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<app-no-results-found [condition]="setups.length === 0"></app-no-results-found>

<div class="flex justify-end mb-5">
  <app-paginacao
    [numeroDeItens]="dadosPaginacao.itensTotal"
    [tamanhoDaPagina]="dadosPaginacao.tamanhoPagina"
    [paginaSelecionada]="dadosPaginacao.paginaSelecionada"
    [totalPage]="dadosPaginacao.totalPaginas"
    (mudouPagina)="mudouPagina.emit($event)"
    (mudouTamanhoPagina)="mudouTamanhoPagina.emit($event)"
  ></app-paginacao>
</div>
